import React, { useEffect } from "react";
import {
    Divider,
    Box,
    // Button,
    // Stack,
    MenuItem,
    Select,
    Grid,
    TextField,
    Typography,
    FormControl,
    InputLabel,
    Autocomplete,
    FormControlLabel,
    Checkbox
} from "@mui/material";
import { Downgraded, useState, createState } from '@hookstate/core';
import ButtonContainer from '../../sharedcomponents/buttoncontainer/buttonContainer';
import Title from '../../sharedcomponents/title/title';
// import RouteConstants from '../../constants/routeConstants';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CustomDialog from '../../sharedcomponents/dialog/dialog';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import TimeSelector from "../../sharedcomponents/timeSelector/timeSelector";
import MUIDatePicker from "../../sharedcomponents/datePicker";
import TinyMCEEditor from "../../sharedcomponents/tinymceEditor/tinymce";


const activityState = createState({
    masterID: 0,
    title: '',
    description: '',
    headerDate: null,
    startTime: null,
    endTime: null,
    duration: null,
    slot: null,
    createdBy: null,
    isDisable: false,
    isRequestTimeSlot: false
});
const AddActivities = (props) => {
    const state = useState(activityState);
    const regex = new RegExp('[^\\s]+')
    const [titleErr, setTitleErr] = React.useState('');
    const [descriptionErr, setDescriptionErr] = React.useState('');
    const [headerDateErr, setHeaderDateErr] = React.useState('');
    const [startTimeErr, setStartTimeErr] = React.useState('');
    const [endTimeErr, setEndTimeErr] = React.useState('')
    // const [durationErr, setDurationErr] = React.useState('')
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');
    const [disableBtn, setDisableBtn] = React.useState(true);
    const tags = useState(null);
    const selectedTags = useState([]);

    const validateTitle = () => {
        let value = state.title.get().trim();
        if (value == '') {
            setTitleErr('Please Enter Title');
        } else {
            setTitleErr('');
            return true;
        }
    };
    const validateDescription = () => {
        let value = state.description.get().trim();
        if (value == '') {
            setDescriptionErr('Please Enter Description');
        } else {
            setDescriptionErr('');
            return true;
        }
    };
    useEffect(() => {
        setRolesNTags(eventInfo.eventID)
        if (props.activityInfo != undefined || props.activityInfo != null) {
            // console.log("props.activityInfo", props.activityInfo);
            state.set({
                masterID: props.activityInfo.masterID,
                title: props.activityInfo.title,
                description: props.activityInfo.description,
                // headerDate: props.activityInfo.dateTime,
                // startTime: props.activityInfo.startTime,
                // startTime: props.activityInfo.tagIDs,
                endTime: props.activityInfo.endTime,
                slot: props.activityInfo.slot,
                duration: props.activityInfo.duration,
                isRequestTimeSlot: props.activityInfo.isRequestTimeSlot
            })
        } else {
            state.set({
                masterID: 0,
                title: '',
                description: '',
                headerDate: null,
                startTime: null,
                endTime: null,
                slot: '',
                createdBy: null,
                isDisable: false,
                isRequestTimeSlot: false
            })
        }
    }, []);
    const setRolesNTags = async (eventID) => {
        const tagsdata = ApiHelper.get(APIURLConstants.GET_TAGS(eventID));
        await Promise.all([tagsdata]).then((data) => {
            const tagsd = data[0].data.filter((item) => item.status == 1);
            if (props.activityInfo != undefined || props.activityInfo != null) {
                const getTags = tagsd.filter((item) =>
                    props.activityInfo
                        ? props.activityInfo.tagIDs.split(', ').includes(item.tagName)
                        : false
                );
                selectedTags.set(getTags);
            }
            tags.set(tagsd);
        });
    };
    // const validateSlot = () =>
    // {
    //     handleDisableBtn()
    //     let value = state.slot.get().trim();
    //     if (value == '')
    //     {
    //         setSlotErr('Please Enter Slot');
    //     } else
    //     {
    //         setSlotErr('');
    //         return true;
    //     }
    // }
    // const validateDuration = () =>
    // {
    //     handleDisableBtn()
    //     let value = state.duration.get().trim();
    //     if (value == '')
    //     {
    //         setDurationErr('Please Enter Duration');
    //     } else
    //     {
    //         setDurationErr('');
    //         return true;
    //     }
    // }
    const slotChanges = (event) => {

        state.slot.set(event.target.value)
        handleDisableBtn()

    }
    const durationChanges = (event) => {

        state.duration.set(event.target.value)
        handleDisableBtn()

    }
    const isValidForm = () => {
        let isValid = true;
        if (state.title.value == '') {
            setTitleErr('Please Enter Title');
            isValid = false;

        }
        else if (state.description.value == '') {
            setDescriptionErr('Please Enter Description');
            isValid = false;
        }
        // else if (state.headerDate.value == null)
        // {
        //     setHeaderDateErr('Please Select Activity date');
        //     isValid = false;
        // }
        // else if (state.startTime.value == null)
        // {
        //     setStartTimeErr('Please Select StartTime');
        //     isValid = false;
        // }
        // else if (state.endTime.value == null)
        // {
        //     setEndTimeErr('Please Select EndTime');
        //     isValid = false;
        // }
        // else if (state.endTime.value < state.startTime.value)
        // {
        //     setEndTimeErr('Please Select EndTime greaterthan StartTime');
        //     isValid = false;
        // }
        // else if (state.slot.value == '')
        // {
        //     setSlotErr('Please Select Slot');
        //     isValid = false;
        // }
        // else if (state.duration.value == null)
        // {
        //     setDurationErr('Please Enter Duration');
        //     isValid = false;
        // }
        else {
            setTitleErr('')
            setDescriptionErr('')
            setHeaderDateErr('')
            setStartTimeErr('')
            setEndTimeErr('')
            // setSlotErr('')
            // setDurationErr('')
        }
        return isValid
    }
    console.log("selectedTags", selectedTags.attach(Downgraded).get());
    const handleClick = () => {
        if (!isValidForm()) {
            return false;
        } else if (selectedTags.attach(Downgraded).get().length == 0) {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please Select Tags'
            });
        }
        else {
            const setUserTags = selectedTags.attach(Downgraded).get()
            const setUserTagsList =
                setUserTags.length > 0
                    ? setUserTags.map((tag) => tag.tagID).join(',')
                    : '';
            let requestObj = {
                "masterID": state.get().masterID,
                "eventID": eventInfo.eventID,
                "title": state.title.get(),
                "description": state.description.get() != '' ? encodeURIComponent(state.description.get()) : state.description.get(),
                "tagIDs": setUserTagsList,
                // "headerDate": `${Helper.FormatYearDate(
                //     state.headerDate.get()
                // )}T${Helper.FormatTime24(state.headerDate.get())}`,
                // // state.headerDate.get(),
                // "startTime": state.startTime.get(),
                // "endTime": state.endTime.get(),
                // "slot": `${state.get().slot}`,
                // "duration": state.duration.get() != undefined && state.get().duration != null ? `${state.get().duration}` : '',
                "createdBy": userInfo.userID,
                "isRequestTimeSlot": state.isRequestTimeSlot.get()
            }
            ApiHelper.post(APIURLConstants.POST_SOCIAL_RESPONSIBILITY_ADD_ACTIVITY, requestObj).then((res) => {

                if (res.data) {
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: props.activityInfo
                            ? 'Activity updated successfully.'
                            : 'Activity created successfully.',
                    });
                    props.handleClose();
                    props.getResults();
                    resetState();
                }
            })
                .catch((err) => {
                    console.log(err);
                    props.setSnackBarProps({
                        ...props.snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Error while adding activity.',
                    });
                });
        }
    }
    const resetState = () => {
        state.set({
            masterID: 0,
            title: '',
            description: '',
            headerDate: null,
            startTime: null,
            endTime: null,
            slot: '',
            duration: null,
            createdBy: null,
            isDisable: false,
            isRequestTimeSlot: false
        })
    }
    const handleHeaderDate = (newValue) => {
        state.headerDate.set(newValue);
        handleDisableBtn()
        let value = state.headerDate.value
        if (value == null) {
            setHeaderDateErr('Please Enter Date');
        } else {
            setHeaderDateErr('');
            return true;
        }
    };
    const handleStartTime = (newValue) => {
        console.log(newValue)
        state.startTime.set(newValue);
        handleDisableBtn()
        let value = state.startTime.value
        if (value == null) {
            setStartTimeErr('Please Enter Start Time');
        } else {
            setStartTimeErr('');
            return true;
        }
    };
    const handleEndTime = (newValue) => {
        state.endTime.set(newValue);
        handleDisableBtn()
        let value = state.endTime.value
        if (value == null) {
            setEndTimeErr('Please Enter End Time');
        } else {
            setEndTimeErr('');
            return true;
        }
    }
    const handleDisableBtn = () => {
        if (props.activityInfo != undefined) {
            const data = props.activityInfo;
            let prevData = {
                title: data.title,
                description: data.description,
                headerDate: data.dateTime,
                startTime: '01/01/2022 ' + data.startTime,
                endTime: '01/01/2022 ' + data.endTime,
                slot: data.slot,
                duration: data.duration,
                isRequestTimeSlot: data.isRequestTimeSlot ? data.isRequestTimeSlot : false
            }

            let currentData = {
                title: state.title.get(),
                description: state.description.get(),
                headerDate: state.headerDate.get(),
                startTime: '01/01/2022 ' + state.startTime.get(),
                endTime: '01/01/2022 ' + state.endTime.get(),
                slot: `${state.slot.get()}`,
                duration: `${state.duration.get()}`,
                isRequestTimeSlot: data.isRequestTimeSlot ? data.isRequestTimeSlot : false
            }
            console.log(prevData)
            console.log(currentData)
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true)
            } else {
                setDisableBtn(false)
            }
        }
    }
    const setEditorValue = (event) => {
        console.log("event", event);
        regex.test(event)
            ? state.description.set(event)
            : state.description.set(event.trim());
        validateDescription();
        handleDisableBtn()
    }
    const renderDialogContent = () => {
        return (
            < >
                {/* <Box
                    className="contentBox"
                    style={{ paddingLeft: '24px', paddingRight: '24px' }}> */}
                <Box component={'form'}>
                    <Title title="Create Activity" />
                    <Box component="div">
                        <Box sx={{ width: '100%' }}>
                            <Grid
                                container
                                rowSpacing={2}
                                columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item lg={12} md={12} xs={12}>
                                    <TextField
                                        size="small"
                                        label="Title"
                                        required
                                        fullWidth
                                        minRows={2}
                                        id="outlined-basic"
                                        variant="outlined"
                                        value={state.title.get()}
                                        onChange={(event) => {
                                            regex.test(event.target.value)
                                                ? state.title.set(event.target.value)
                                                : state.title.set(event.target.value.trim());
                                            validateTitle();
                                            handleDisableBtn()
                                        }}
                                        error={titleErr.length > 0 ? true : false}
                                        helperText={
                                            titleErr.length > 0 ? titleErr : ''
                                        }
                                        inputProps={{ maxLength: 250 }}

                                    />
                                </Grid>
                                <Grid item lg={12} md={12} xs={12}>
                                    {tags.get() ? (
                                        <Autocomplete
                                            multiple
                                            id="size-small-standard-multi"
                                            size="small"
                                            options={tags.attach(Downgraded).get()}
                                            getOptionLabel={(option) => option.tagName}
                                            value={selectedTags.attach(Downgraded).get()}
                                            onChange={(event, newValue) => {
                                                setDisableBtn(false)
                                                selectedTags.set(newValue);
                                            }}
                                            // defaultValue={[top100Films[1]]}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder="Tags*"
                                                />
                                            )}
                                        />
                                    ) : null}
                                </Grid>
                                <Grid item lg={12} md={12} xs={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color={'primary'}
                                                size={'small'}
                                                checked={state.isRequestTimeSlot.get()}
                                                onChange={(event) => {
                                                    state.isRequestTimeSlot.set(event.target.checked);
                                                    handleDisableBtn();
                                                }}
                                                inputProps={{ 'aria-label': 'controlled' }}
                                            />
                                        }
                                        label={`Request Time Slot`} />
                                </Grid>
                                <Grid item lg={12} md={12} xs={12}>
                                    <TinyMCEEditor
                                        value={state.description.attach(Downgraded).get()}
                                        setValue={setEditorValue}
                                        enableImageEncode
                                    />
                                    {descriptionErr ? <Typography
                                        sx={{
                                            fontSize: 12,
                                            color: 'red',
                                            p: 1
                                        }}>
                                        Please Enter Description
                                    </Typography> : null}
                                    {/* <TextField
                                        size="small"
                                        label="Description"
                                        multiline
                                        minRows={4}
                                        required
                                        fullWidth
                                        id="outlined-basic"
                                        variant="outlined"
                                        value={state.description.get()}
                                        onChange={(event) =>
                                        {
                                            regex.test(event.target.value)
                                                ? state.description.set(event.target.value)
                                                : state.description.set(event.target.value.trim());
                                            validateDescription();
                                            handleDisableBtn()
                                        }}
                                        error={descriptionErr.length > 0 ? true : false}
                                        helperText={
                                            descriptionErr.length > 0 ? descriptionErr : ''
                                        }
                                    /> */}
                                </Grid>
                            </Grid>
                        </Box>
                        {/* <Divider
                            light={false}
                            sx={{ mt: 2, marginRight: 0, mb: 2 }}
                            flexItem
                        /> */}
                        {/* <Box component='div' sx={{ width: '100%' }}>
                            <Typography fontWeight={600} sx={{ mb: 2 }}>
                                Activity Timing Details
                            </Typography>
                            <Grid
                                container
                                rowSpacing={2}
                                columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item lg={6} md={6} xs={12}>
                                    <MUIDatePicker
                                        label="Activity Date"
                                        value={state.headerDate
                                            .attach(Downgraded)
                                            .get()}
                                        error={headerDateErr}
                                        setValue={handleHeaderDate}
                                    />
                                    {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Activity Date"
                                            value={state.headerDate
                                                .attach(Downgraded)
                                                .get()}
                                            inputProps={{ readOnly: true }}
                                            minDate={new Date()}
                                            onChange={(newValue) =>
                                                handleHeaderDate(newValue)
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    required
                                                    size="small"
                                                    helperText={headerDateErr}
                                                    autoComplete="off"
                                                    onKeyDown={(e) =>
                                                        e.preventDefault()
                                                    }
                                                    error={
                                                        headerDateErr.length > 0
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            )}
                                        />
                                    </LocalizationProvider> */}
                        {/* </Grid>
                                <Grid item lg={6} md={6} xs={12}>
                                    <TimeSelector
                                        label='Start Time'
                                        value={state.startTime.get()}
                                        onChange={handleStartTime}
                                        errorMsg={startTimeErr}
                                    /> */}
                        {/* <LocalizationProvider dateAdapter={AdapterDateFns}>

                                        <TimePicker
                                            label="Start Time"
                                            value={state.startTime
                                                .attach(Downgraded)
                                                .get()}
                                            onChange={(newValue) =>
                                                handleStartTime(newValue)

                                            }
                                            renderInput={(params) => <TextField {...params} required
                                                size="small"
                                                fullWidth
                                                helperText={startTimeErr}
                                                autoComplete="off"
                                                onKeyDown={(e) =>
                                                    e.preventDefault()
                                                }
                                                error={
                                                    startTimeErr.length > 0
                                                        ? true
                                                        : false
                                                } />}
                                        />
                                    </LocalizationProvider> */}
                        {/* </Grid>
                                <Grid item lg={6} md={6} xs={12}>
                                    <TimeSelector
                                        label='End Time'
                                        value={state.endTime.get()}
                                        onChange={handleEndTime}
                                        errorMsg={endTimeErr}
                                    /> */}
                        {/* <LocalizationProvider dateAdapter={AdapterDateFns}>

                                        <TimePicker
                                            label="End Time"

                                            value={state.endTime
                                                .attach(Downgraded)
                                                .get()}
                                            onChange={(newValue) =>
                                                handleEndTime(newValue)
                                            }
                                            renderInput={(params) => <TextField {...params} required
                                                size="small"
                                                helperText={endTimeErr}
                                                fullWidth
                                                autoComplete="off"
                                                onKeyDown={(e) =>
                                                    e.preventDefault()
                                                }
                                                error={
                                                    endTimeErr.length > 0
                                                        ? true
                                                        : false
                                                } />}
                                        />
                                    </LocalizationProvider> */}
                        {/* </Grid>
                                <Grid item lg={6} md={6} xs={12}>
                                    <FormControl fullWidth={true} size="small">
                                        <InputLabel id="demo-simple-select-label">Slot (mins)</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={state.slot.get()}
                                            label="Slot (mins)"
                                            fullWidth
                                            // defaultValue={Slot}
                                            onChange={(event) =>
                                            {
                                                slotChanges(event)
                                            }
                                            }>
                                            <MenuItem value={15}>15</MenuItem>
                                            <MenuItem value={30}>30</MenuItem>
                                            <MenuItem value={45}>45</MenuItem>
                                            <MenuItem value={60}>60</MenuItem>

                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item lg={6} md={6} xs={12}>
                                    <FormControl fullWidth={true} size="small">
                                        <InputLabel id="demo-simple-select-label">Duration (mins)</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={state.duration.get()}
                                            label="Duration (mins)"
                                            onChange={(event) =>
                                            {
                                                durationChanges(event)
                                            }
                                            }>
                                            <MenuItem value={30}>30</MenuItem>
                                            <MenuItem value={60}>60</MenuItem>

                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid> */}
                        {/* </Box> */}
                    </Box>
                </Box>
                {/* </Box> */}
            </>
        )
    }
    const renderDialogActions = () => {
        return (
            <ButtonContainer
                handleClick={handleClick}
                handleCancel={props.handleCloseModule}
                buttonText={state.get().masterID === 0 ? 'Submit' : 'Update'}
                disableUpdateButton={props.activityInfo ? disableBtn : false}
            />
        );
    };
    return (
        <CustomDialog
            handleClose={props.handleCloseModule}
            open={props.open}
            fullWidth={true}
            maxWidth={'sm'}
            renderContent={renderDialogContent}
            renderActions={renderDialogActions}
            disableEnforceFocus={true}
        />
    );
}
// export default {
//     routeProps: {
//         path: [RouteConstants.CREATE_ADDACTIVITIES, RouteConstants.EDIT_ADDACTIVITIES,],
//         component: AddActivities,
//     },
//     name: 'AddActivities',
// }
export default AddActivities